import _ from 'lodash'
import dayjs from 'dayjs'
import { deleteItem, getJSON } from '../common/services/api'
import { gaEvent } from '../common/services/analytics'
import * as TodoActions from '../actions/Todos'

export function deleteSingleTodo(task) {
  return (dispatch, getState) => {
    const { recurring, today } = getState().todos
    const recurringTask = _.find(recurring, { id: task.recurringTask })
    const dailyTasks = _.find(today, { id: task.recurringTask })

    const isLastTask =
      recurringTask &&
      recurringTask.recurrence === 'once' &&
      dailyTasks.tasks.length === 1

    const list = isLastTask ? 'recurring-tasks' : 'tasks'
    const id = isLastTask ? recurringTask.id : task._id
    return deleteItem(id, list)
      .then(() => {
        dispatch(fetchDailyTodos())
        gaEvent({
          category: 'ToDos',
          action: `Deleted single`,
        })
      })
      .catch((err) => {
        console.log(err)
      })
  }
}

export function deleteRecurringTodo(id) {
  return (dispatch) => {
    return deleteItem(id, 'recurring-tasks')
      .then(() => {
        dispatch(fetchRecurringTodos())
        gaEvent({
          category: 'ToDos',
          action: `Deleted recurring`,
        })
      })
      .catch((err) => {
        console.log(err)
      })
  }
}

export function fetchDailyTodos() {
  return (dispatch, getState) => {
    dispatch(TodoActions.setDailyTodos(null)) // show loading in todos dashboard
    const date = getState().todos.currentDate || dayjs()
    let url = `/api/list/tasks/dashboard`
    if (date) url += `?on=${date.toISOString()}`
    return getJSON({ url })
      .then((res) => {
        const todos = res.result
        dispatch(TodoActions.setDailyTodos(todos))
      })
      .catch((e) => {
        console.log(e)
      })
  }
}

export function fetchRecurringTodos() {
  return (dispatch) => {
    dispatch(TodoActions.setRecurringTodos(null))
    const url = `/api/list/recurring-tasks?sort=-startDate`
    return getJSON({ url })
      .then((res) => {
        const recurringTodos = res.result
        dispatch(TodoActions.setRecurringTodos(recurringTodos))
      })
      .catch((e) => {
        console.log(e)
      })
  }
}
